"use client";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { cn } from "../utils/cn";
import Modal from './Modal';
import React, { useState, useCallback } from 'react'
import _ from 'lodash';
import { Link } from 'react-router-dom';

// TODO Maybe don't use these? idk notification is pretty good

// TODO Refactor these
import { useSignup } from '../hooks/authentication_helper'
import { useUser } from '../hooks/useUser';
import LabelInputContainer from "./ui/LabelInputContainer";
import Checkbox from "./ui/checkbox";

const StyledErrorMessage: React.FC<{ errors: { [field: string]: [string] } }> = (props) => {
  return <div>
    {Object.entries(props.errors).map(([field, errors]) => {
      return <div key={field} className="text-red-500 bold">{_.startCase(field)}: <br /><ul>{errors.map(text => <li key={text}>{text}</li>)}</ul></div>
    })}
  </div>
}

const BottomGradient = () => {
  return (
    <>
      <span className="group-hover/btn:opacity-100 block transition duration-500 opacity-0 absolute h-px w-full -bottom-px inset-x-0 bg-gradient-to-r from-transparent via-cyan-500 to-transparent" />
      <span className="group-hover/btn:opacity-100 blur-sm block transition duration-500 opacity-0 absolute h-px w-1/2 mx-auto -bottom-px inset-x-10 bg-gradient-to-r from-transparent via-indigo-500 to-transparent" />
    </>
  );
};

export const SignupForm = ({successCallback, teaser, title}: {successCallback?: () => void, teaser?: boolean, title?: string  }) => {
  const [email, setEmail] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [agreeToTerms, setAgreeToTerms] = useState<boolean>(false);
  const [confirmPassword, setConfirmPassword] = useState<string>();
  const signup = useSignup();
  const userApi = useUser();



  const signupIfPasswordsMatch = useCallback(() => {
    if (password !== confirmPassword) {
      alert("Passwords do not match")
      return
    }

    if (!email || !firstName || !lastName || !password || !confirmPassword) {
      alert("Please fill out all fields")
      return
    }

    if (!agreeToTerms) {
      alert("You must agree to the terms to use this service")
      return
    }

    signup(email, firstName, lastName, password)
      .then((result) => {
        if (result.success) {
          if (userApi.state === "LoggedOut") userApi.updateUserInfo();
          else console.warn("Attempted signup while logged in")
          if(successCallback) {
            successCallback()
          }
          alert("Signup successful")
        } else {
          let errorMsg = "Signup failed"
          try {
            if (result?.error?.response?.data?.error) {
              // Handle both string and object error formats
              const errorData = result.error.response.data.error;
              if (typeof errorData === 'object') {
                // Convert object with array values to string
                errorMsg = Object.entries(errorData)
                  .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
                  .join('\n');
              } else {
                errorMsg = errorData;
              }
            }
          } catch (e) {
            console.error('Error parsing error message:', e);
            errorMsg = "An unexpected error occurred during signup";
          }
          alert(errorMsg)
        }
      })
  }, [email, password, signup])




  return (
    <div className="max-w-md w-full mx-auto rounded-none md:rounded-2xl p-4 md:p-8 shadow-input text-white bg-gray-900">
      <h2 className="font-bold text-xl text-white">
        {title || "Welcome to Thoughtful Oasis"}
      </h2>

      <div className="my-8">
        <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2 mb-4">
          <LabelInputContainer>
            <Label htmlFor="firstname" className="text-white">First name</Label>
            <Input 
              id="firstname" 
              placeholder="Rachel" 
              type="text" 
              value={firstName} 
              onChange={(e) => setFirstName(e.target.value)} 
            />
          </LabelInputContainer>
          <LabelInputContainer>
            <Label htmlFor="lastname" className="text-white">Last name</Label>
            <Input 
              id="lastname" 
              placeholder="Carson" 
              type="text" 
              value={lastName} 
              onChange={(e) => setLastName(e.target.value)} 
            />
          </LabelInputContainer>
        </div>
        <LabelInputContainer className="mb-4">
          <Label htmlFor="email" className="text-white">Email Address</Label>
          <Input
            id="email"
            placeholder="janejacobs@greenwichvillage.com" 
            type="email" 
            value={email} onChange={(e) => setEmail(e.target.value)} 
          />
        </LabelInputContainer>
        <LabelInputContainer className="mb-4">
          <Label htmlFor="password" className="text-white">Password</Label>
          <Input
            id="password"
            placeholder="••••••••"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </LabelInputContainer>
        <LabelInputContainer className="mb-8">
          <Label htmlFor="confirmpassword" className="text-white">Conform Password</Label>
          <Input
            id="confirmpassword"
            placeholder="••••••••"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </LabelInputContainer>
        <Checkbox
          checked={agreeToTerms}
          onChange={(e) => setAgreeToTerms(e.target.checked)}>
          I agree to both the <Link to="/tos">Terms of Service</Link> and the <Link to="/privacy-policy">Privacy Policy</Link>
        </Checkbox>
        <button
          className="mt-4 bg-gradient-to-br relative group/btn from-blue-600 to-blue-800 block w-full text-white rounded-md h-10 font-medium shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset]"
          type="submit"
          onClick={signupIfPasswordsMatch}
        >
          Sign up &rarr;
          <BottomGradient />
        </button>
        {
          teaser && <div className="pt-2 pb-3 text-sm text-white"> <div className="py-2">Interested in other AI Applications?</div> <Link to="/learn-more" target="_blank" rel="noopener noreferrer"  className="shadow-[0_0_0_3px_#ffffff_inset] px-6 py-2 bg-transparent border border-white text-white rounded-lg font-bold transform hover:-translate-y-1 transition duration-400">Learn More</Link></div>
        }


      </div>
    </div>
  );
}

const SignUpButton = ({className}: {className?: string}) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  return (<>
    <Modal
      isOpen={modalIsOpen}
      onClose={() => (setIsOpen(false))}
    >
      <div css={cn('bg-gray-900')}>
        <SignupForm />
      </div>
    </Modal>
    <button onClick={() => { setIsOpen(true) }} className={cn("shadow-[0_0_0_3px_#ffffff_inset] h-fit px-6 py-2 bg-transparent border border-white text-white rounded-lg font-bold transform hover:-translate-y-1 transition duration-400", className)}>
      Sign Up
    </button>
  </>
  )
}


export const SignUpItem = ({className, title}: {className?: string, title?: string}) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  return (<>
    <Modal
      isOpen={modalIsOpen}
      onClose={() => (setIsOpen(false))}
    >
      <div css={cn('bg-gray-900')}>
        <SignupForm title={title} />
      </div>
    </Modal>
    <div className={cn("cursor-pointer", className)} onClick={() => { setIsOpen(true) }}>
      Sign Up
    </div>
  </>
  )
}

export default SignUpButton;